import type { NihaoBridgeContent } from "./types";

export const nihaoBridgeContentTh: NihaoBridgeContent = {
  hero: {
    brandName: "Nihao Bridge",
    headline: "Reach Chinese Customers on RedBook",
    subheadline:
      "Just sign up and we do the rest. We handle content creation, posting, and reporting automatically.",
    ctaButton: "Get Started",
  },
  whyRedBook: {
    title: "Why RedBook Marketing?",
    paragraph1:
      "RedBook (Xiaohongshu / \u5c0f\u7ea2\u4e66) is the largest Chinese lifestyle platform with over 200 million monthly active users. It's where Chinese consumers discover products, read reviews, and make purchasing decisions.",
    paragraph2:
      "For Thai businesses targeting Chinese-speaking tourists and customers, RedBook is the most effective marketing channel to build brand awareness and drive sales.",
  },
  whatWeDo: {
    title: "What We Do For You",
    services: [
      {
        icon: "person-badge",
        title: "Account Setup",
        description:
          "We handle everything — account creation, verification, and ongoing management. You don't lift a finger.",
      },
      {
        icon: "brush",
        title: "Content Creation",
        description:
          "Just send us your photos. We handle translation, copywriting, and design — delivered automatically.",
      },
      {
        icon: "graph-up",
        title: "Posting & Reporting",
        description:
          "Content goes live on schedule. You receive automatic reports — no action required on your end.",
      },
    ],
  },
  postTypes: {
    title: "Types of Marketing Posts",
    types: [
      {
        icon: "building",
        title: "Official Posts",
        description:
          "Professional posts on your business's official RedBook account. Build your brand presence and credibility.",
        colorScheme: "cyan",
      },
      {
        icon: "people",
        title: "UGC Posts",
        description:
          "User-Generated Content from regular users with small followings. Improves your brand's search exposure and organic visibility.",
        colorScheme: "green",
      },
      {
        icon: "star",
        title: "KOC Posts",
        description:
          "Key Opinion Consumer posts from micro-influencers (~10K followers). Boosts engagement and conversion rates.",
        colorScheme: "amber",
      },
    ],
  },
  pricing: {
    title: "Simple, Transparent Pricing",
    subtitle: "Choose the plan that fits your business needs",
    plans: [
      {
        name: "Starter",
        price: "5,900",
        currency: " THB",
        period: "/mo",
        description: "Perfect for small businesses",
        features: [
          "4 Official posts/month",
          "Account management",
          "Monthly report",
        ],
      },
      {
        name: "Growth",
        price: "7,900",
        currency: " THB",
        period: "/mo",
        description: "For growing businesses",
        features: [
          "8 Official posts/month",
          "4 UGC posts/month",
          "Account management",
          "Weekly report",
        ],
        isPopular: true,
        popularLabel: "Popular",
      },
      {
        name: "Premium",
        price: "9,900",
        currency: " THB",
        period: "/mo",
        description: "Full-scale marketing",
        features: [
          "12 Official posts/month",
          "8 UGC posts/month",
          "2 KOC posts/month",
          "Priority support",
        ],
      },
    ],
    footnote:
      "* Minimum 3 months commitment. All plans include RedBook account setup and management.",
  },
  cta: {
    title: "Ready to Grow Your Business?",
    description:
      "We're launching soon. Contact us now to get early access, exclusive pricing, and be among the first to reach Chinese customers on RedBook.",
    contactButton: "Contact Us",
    loginButton: "Login to Portal",
  },
};
